
import CrmHistory from "@/models/crm/crm-history";
import CrmEditCall from "./edit/CrmEditCall.vue";
import CrmEditAppointment from "./edit/CrmEditAppointment.vue";
import CrmEditClose from "./edit/CrmEditCloseEvent.vue";
import CrmEditEmail from "./edit/CrmEditEmailEvent.vue";
import CrmEditMessage from "./edit/CrmEditMessageEvent.vue";
import CrmEditFile from "./edit/CrmEditFileEvent.vue";
import AppCalendarEventEdit from "@/components/calendar/CalendarEventEditCard.vue";

import Vue from "vue";
import { Contact } from "@/models/base";
import Crm from "@/models/crm/crm";
import {CalendarEvent} from "@/models/calendar-event";

export default Vue.extend({
	data() {
		return {
			addOnCalendar: false,
			addCalendarEvent: false,
			toEditEvent: null as null | CalendarEvent,
		};
	},
	props: {
		event: Object as () => CrmHistory,
		contact: {
			required: true,
			type: Object as () => Contact,
		},
		crm: {
			required: false,
			type: Object as () => Crm,
		},
	},
	computed: {
		title():string {
			return this.$ct("event-titles." + this.event.EventTypeID).toString();
		}
	},
	watch: {
		"event.Props"(){
			this.event?.getEventProps();
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		preSave(){
			if(this.addOnCalendar){
				this.toEditEvent = new CalendarEvent();
				this.toEditEvent.StartTime = (this.event.Props as any).TimeStamp;
				this.toEditEvent.EndTime = new Date(this.toEditEvent.StartTime);
				this.toEditEvent.EndTime.setHours(this.toEditEvent.EndTime.getHours() + 1);
				this.toEditEvent.Title = (this.event.Props as any).Message;
				this.toEditEvent.CrmID = this.crm ? this.crm.ID : 0;
				this.addCalendarEvent = true;
			}else if(this.event.ID){
				this.event.ComputedProps =  this.event.getEventProps();
				this.$emit("update",this.event);
			}else{
				this.$emit("save", this.event);
			}
		},
		async save() {
			this.$emit("save", this.event);
		}
	},
	components: {
		CrmEditCall,
		CrmEditAppointment,
		CrmEditEmail,
		CrmEditMessage,
		CrmEditClose,
		CrmEditFile,
		AppCalendarEventEdit
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
